import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { log } from "../../Helper";
import { bindActionCreators } from "redux";
import * as loadBuildActionCreators from "../orders/actions";
import * as spinnerStateActionCreator from "../../formControl/actions";
import { useDispatch } from "react-redux";
import { Col } from "../../components/Layout";
import { Row } from "../../components/Layout";
import moment from "moment";
import { useDropzone } from "react-dropzone";
import dayjs from 'dayjs';
import { toast } from "react-toastify";
import { TruckFormElements } from "./TruckFormElements";
import { VesselFormElements } from "./VesselFormElements";
import { FormFileUpload } from "./formFileUpload";
import SelectedMachinesTable from "./selectedMachinesTable";
import FormSpinner from "./formSpinner";
import { PostAvisData } from "./api";
import { useUserInfo } from "../../common/user-context";
import { ARRIVAL_DATE_ERROR_TEXT } from "../orders/utility/constants";
import { PLANNED_LOADING_DATE_ERROR_TEXT } from "../orders/utility/constants";
import { INVALID_DATE_ERROR_TEXT } from "../orders/utility/constants";
import { set } from "date-fns";

function AvisLoadBuildForm({ selectedMachinesForBuildProp, uniqueTruckDetailsDTOList, imoList, locationList }) {
  const props = [selectedMachinesForBuildProp];
  const [selectedMachinesForBuild, setSelectedMachinesForBuild] = useState([]);
  const initialFreetext = [];
  const initialAvisDate = "";
  const initialEstimatedArrivalDate = "";
  const initialTruckPlate = "";
  const initialTrailorPlate = "";
  const initialDriverName = "";
  const initialAvisDateErrorMessage = "";
  const initialEstimatedArrivalDateErrorMessage = "";
  const [startSpinner, setStartSpinner] = useState(false);
  const [acceptedFiles, setAcceptedFiles] = useState([]);
  const [isFileSelected, setIsFileSelected] = useState(false);

  const { userData } = useUserInfo();

  const handleCloseSpinner = (event, reason) => {
    if (reason !== "backdropClick") {
      setStartSpinner(false);
    }
  };

  const [freetext, setFreeText] = useState(initialFreetext);
  const [avisDate, setAvisDate] = useState(initialAvisDate);
  const [estimatedArrivalDate, setEstimatedArrivalDate] = useState(initialEstimatedArrivalDate);
  const [truckPlate, setTruckPlate] = useState(initialTruckPlate);
  const [trailorPlate, setTrailorPlate] = useState(initialTrailorPlate);
  const [driverName, setDriverName] = useState(initialDriverName);

  const [avisDateError, setAvisDateError] = useState(false);
  const [estimatedArrivalDateError, setEstimatedArrivalDateError] = useState(false);
  const [estimatedArrivalDateErrorMessage, setEstimatedArrivalDateErrorMessage] = useState(initialEstimatedArrivalDateErrorMessage);
  const [truckplateError, setTruckPlateError] = useState(false);
  const [trailorplateError, setTrailorPlateError] = useState(false);
  const [driverNameError, setDriverNameError] = useState(false);
  const [avisDateErrorMessage, setAvisDateErrorMessage] = useState(initialAvisDateErrorMessage)
  const [triggerLoadBuildState, setTriggerLoadBuildState] = useState(false);
  const [highlightedDatesForPickUp, setHighlightedDatesForPickUp] = useState('');
  const { avisLoadBuildValidateAction, triggerLoadBuildActionByAvis } = bindActionCreators(loadBuildActionCreators, useDispatch());

  const [portError, setPortError] = useState(false);
  const [blNumberError, setBlNumberError] = useState(false);
  const [containerNumberError, setContainerNumberError] = useState(false);
  const [sailDateError, setSailDateError] = useState(false);
  const [etaError, setEtaError] = useState(false);
  const transportMode = selectedMachinesForBuildProp?.transportMode;

  const { setSpinnerState } = bindActionCreators(
    spinnerStateActionCreator,
    useDispatch()
  );
  let triggerLoadBuild = useSelector(
    (storeState) => storeState.triggerLoadBuildAvis
  );

  let sapSupplierNumber = useSelector((storeState) => storeState.setProvider);
  let supplierNumber = userData.supplierNumber;

  const handleDrop = (acceptedFiles) => {
    setAcceptedFiles(acceptedFiles);
    setIsFileSelected(true);
    log("files", acceptedFiles);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let isCorrect = true;

    const data = new FormData(event.target);
    let inputAvisDate = data.get("textField-datePicker-avisdate") ? dayjs(data.get("textField-datePicker-avisdate")).format('YYYY-MM-DDTHH:mm') : '';
    let inputEstimatedArrivalDate = data.get("textField-datePicker-estimatedArrivalDate") ? dayjs(data.get("textField-datePicker-estimatedArrivalDate")).format('YYYY-MM-DD') : '';
    let inputTruckPlate = data.get("truckplate");
    let inputTrailorPlate = data.get("trailorplate");
    let inputDriverName = data.get("driverName");
    let portOfEntryId = data.get("portOfEntry");
    let portOfExitId = data.get("portOfExit");
    let imoNumber = data.get("vessel")
      ? String(data.get("vessel").match(/\((\d+)\)/)?.[1] ?? '').trim()
      : ''; //extract imoNumber and assign its value to imoNumber
    let blNumber = data.get("blNumber");
    let containerNumber = data.get("containerNumber");
    let sailDate = data.get("sailDate");
    let eta = data.get("eta");

    log("acceptedFiles-- ", acceptedFiles.length);

    if (transportMode === "TRUCK" || transportMode === null) {
      if (
        _.isEqual(freetext.trim(), data.get("freetext").trim()) &&
        _.isEqual(avisDate.trim(), inputAvisDate.trim()) &&
        _.isEqual(estimatedArrivalDate.trim(), inputEstimatedArrivalDate.trim()) &&
        _.isEqual(truckPlate.trim(), inputTruckPlate.trim()) &&
        _.isEqual(trailorPlate.trim(), inputTrailorPlate.trim()) &&
        _.isEqual(driverName.trim(), inputDriverName.trim()) &&
        acceptedFiles.length === 0
      ) {
        isCorrect = false;
        log("No data change--");
        toast.warn("No data change to update");
      }


      let platePattern = /[A-Za-z0-9 ]{2,15}/;
      let namePattern = /[A-Za-z ]{2,50}/;

      setAvisDateError(false);
      setEstimatedArrivalDateError(false);
      setTruckPlateError(false);
      setTrailorPlateError(false);
      setDriverNameError(false);

      if (null != inputAvisDate && !_.isEqual(inputAvisDate, "") && !_.isEqual(inputAvisDate, avisDate)) {
        if (moment(inputAvisDate, "YYYY/MM/DD HH:mm").isBefore(moment())) {
          setAvisDateError(true);
          isCorrect = false;
          setAvisDateErrorMessage(INVALID_DATE_ERROR_TEXT)
        }
        else if (moment(inputEstimatedArrivalDate, "YYYY/MM/DD").isBefore(moment(inputAvisDate, "YYYY/MM/DD"))) {
          setAvisDateError(true);
          isCorrect = false;
          setAvisDateErrorMessage(PLANNED_LOADING_DATE_ERROR_TEXT)
        }

      }
      if (null != inputEstimatedArrivalDate && !_.isEqual(inputEstimatedArrivalDate, "") && !_.isEqual(inputEstimatedArrivalDate, estimatedArrivalDate)) {
        if (moment(inputEstimatedArrivalDate, "YYYY/MM/DD HH:mm").isBefore(moment())) {
          setEstimatedArrivalDateError(true);
          isCorrect = false;
          setEstimatedArrivalDateErrorMessage(INVALID_DATE_ERROR_TEXT)
        }
        else if (moment(inputEstimatedArrivalDate, "YYYY/MM/DD").isBefore(moment(inputAvisDate, "YYYY/MM/DD"))) {
          setEstimatedArrivalDateError(true);
          isCorrect = false;
          setEstimatedArrivalDateErrorMessage(ARRIVAL_DATE_ERROR_TEXT)
        }
      }

      if (null != inputTruckPlate && !_.isEqual(inputTruckPlate, "")) {
        if (!platePattern.test(inputTruckPlate)) {
          setTruckPlateError(true);
          isCorrect = false;
        }
      }

      if (null != inputTrailorPlate && !_.isEqual(inputTrailorPlate, "")) {
        if (!platePattern.test(inputTrailorPlate)) {
          setTrailorPlateError(true);
          isCorrect = false;
        }
      }

      if (null != inputDriverName && !_.isEqual(inputDriverName, "")) {
        if (!namePattern.test(inputDriverName)) {
          setDriverNameError(true);
          isCorrect = false;
        }
      }
    }
    else if (transportMode === "VESSEL" || transportMode === "FERRY") {
      // Validate vessel-related fields
      if (
        _.isEqual(freetext.trim(), data.get("freetext").trim()) &&
        _.isEqual(portOfEntryId, initialPortOfEntryId) &&
        _.isEqual(portOfExitId, initialPortOfExitId) &&
        _.isEqual(imoNumber, initialImoNumber) &&
        _.isEqual(blNumber, initialBlNumber) &&
        _.isEqual(containerNumber, initialContainerNumber) &&
        _.isEqual(sailDate, initialSailDate) &&
        _.isEqual(eta, initialEta) &&
        acceptedFiles.length === 0
      ) {
        isCorrect = false;
        log("No data change--");
        toast.warn("No data change to update");
      }

      let blNumberPattern = /^.{8,16}$/;
      let containerNumberPattern = /^[A-Za-z0-9]{11}$/;
      const minSailDate = dayjs().subtract(60, 'day').format('YYYY-MM-DD');
      const maxSailDate = dayjs().add(60, 'day').format('YYYY-MM-DD');
      const minEtaDate = dayjs().subtract(60, 'day').format('YYYY-MM-DD');
      const maxEtaDate = dayjs().add(180, 'day').format('YYYY-MM-DD');

      if ((portOfExitId != null && !_.isEqual(portOfExitId, "")) || (portOfEntryId != null && !_.isEqual(portOfEntryId, ""))) {
        if (portOfEntryId === portOfExitId) {
          isCorrect = false;
          setPortError(true);
        }
      } else setPortError(false);
      if (null != blNumber && !_.isEqual(blNumber, "")) {
        if (!blNumberPattern.test(blNumber)) {
          isCorrect = false;
          setBlNumberError(true);
        }
      } else setBlNumberError(false);
      if (null != containerNumber && !_.isEqual(containerNumber, "")) {
        if (!containerNumberPattern.test(containerNumber)) {
          isCorrect = false;
          setContainerNumberError(true);
        }
      } else setContainerNumberError(false);

      if (null != sailDate && !_.isEqual(sailDate, "")) {
        if (moment(sailDate, "YYYY/MM/DD").isBefore(minSailDate) || moment(sailDate, "YYYY/MM/DD").isAfter(maxSailDate)) {
          isCorrect = false;
          setSailDateError(true);
        } else setSailDateError(false);
      }
      if (null != eta && !_.isEqual(eta, "")) {
        if ((moment(eta, "YYYY-MM-DD").isBefore(sailDate) || moment(eta, "YYYY/MM/DD").isBefore(minEtaDate)
          || moment(eta, "YYYY/MM/DD").isAfter(maxEtaDate))) {
          isCorrect = false;
          setEtaError(true);
        } else setEtaError(false);
      }
    }

    if (isCorrect) {
      setStartSpinner(true);
      const orderPathId = [];
      for (var i = 0; i < selectedMachinesForBuild.length; i++) {
        let orderPathNumberArray = selectedMachinesForBuild[i].orderPathId
          .split(",")
          .map(Number);
        for (var i = 0; i < orderPathNumberArray.length; i++) {
          orderPathId.push(orderPathNumberArray[i]);
        }
      }
      log("Selected machines orderPathIds :", orderPathId);
      const reqObj = {
        orderPathId: orderPathId,
        freetext: data.get("freetext"),
        buildId: props[0].buildId,
        shippingOrder: props[0].shpOrder,
        trailerPlate: inputTrailorPlate,
        truckPlate: inputTruckPlate,
        avisDate: inputAvisDate,
        estimatedArrivalDate: inputEstimatedArrivalDate,
        driverName: inputDriverName,
        sapSupplierNumber: _.isEmpty(sapSupplierNumber)
          ? supplierNumber
          : sapSupplierNumber,
        portOfEntryId: portOfEntryId,
        portOfExitId: portOfExitId,
        imoNumber: imoNumber,
        blNumber: blNumber,
        containerNumber: containerNumber,
        sailDate: sailDate,
        vesselETA: eta,
        transportMode: transportMode,
      };
      log("updateLoadBuild req", reqObj);
      PostAvisData(
        reqObj,
        acceptedFiles,
        setStartSpinner,
        avisLoadBuildValidateAction,
        triggerLoadBuildActionByAvis,
        setSpinnerState
      );
    } else {
      triggerLoadBuildActionByAvis(false);
      avisLoadBuildValidateAction(false);
    }
  };

  useEffect(() => {
    setTriggerLoadBuildState(triggerLoadBuild);
  });

  useEffect(() => {
    if (triggerLoadBuildState) {
      submitForm.click();
    }
  }, [triggerLoadBuildState]);

  const [totalWeight, setTotalWeight] = useState(0);

  const truckPlateList = [uniqueTruckDetailsDTOList];

  const handleTruckPlateChange = (event) => {
    const enteredText = event.target.value;
    if (truckPlateList) {
      const matchingOption = truckPlateList[0].find(item =>
        item.truckPlate.toLowerCase() === enteredText.toLowerCase()
      );

      if (matchingOption) {
        setTrailorPlate(matchingOption.trailerPlate);
        setDriverName(matchingOption.driverName);
      }
      else {
        setTrailorPlate('');
        setDriverName('');
      }
    }
  };


  useEffect(() => {

    log("triggerLoadBuild in avisform: ", triggerLoadBuild);
    log("selectedMachinesForBuildProp in avisform: ", selectedMachinesForBuildProp);
    let machine = [];
    let tempFreetext = freetext;
    let tempDriverName = driverName;
    let tempTruckPlate = truckPlate;
    let tempTrailerPlate = trailorPlate;
    let tempAvisDate = avisDate;
    let tempEstimatedArrivalDate = estimatedArrivalDate;

    let totalWeight = 0;
    log("props", props);
    for (let i = 0; i < Object.keys(props).length; i++) {
      machine.push(props[i]);
      tempFreetext = _.concat(tempFreetext, props[i].freetext);
      tempDriverName = _.concat(tempDriverName, props[i].driverName);
      tempTruckPlate = _.concat(truckPlate, props[i].truckPlate);
      tempTrailerPlate = _.concat(trailorPlate, props[i].trailerPlate);
      tempAvisDate = _.toString(props[i].avisDate);
      tempEstimatedArrivalDate = _.toString(props[i].estimatedArrivalDate);
      totalWeight = totalWeight + parseInt(props[i].weight);
    }
    setTotalWeight(totalWeight);
    const driverNameSet = new Set(tempDriverName);
    const truckPlateSet = new Set(tempTruckPlate);
    const trailerPlateSet = new Set(tempTrailerPlate);
    setFreeText(tempFreetext.filter(Boolean).join("\n"));
    setDriverName(Array.from(driverNameSet).join("\n"));
    setTrailorPlate(Array.from(trailerPlateSet).join("\n"));
    setTruckPlate(Array.from(truckPlateSet).join("\n"));
    setAvisDate(
      _.isNull(props[0].avisDate) ? "" : props[0].avisDate.substring(0, 16)
    );
    setEstimatedArrivalDate(
      _.isNull(props[0].estimatedArrivalDateAvis) ? "" : props[0].estimatedArrivalDateAvis.split(",")[0].split(":")[1]
    );
    log("trailerPlateSet", trailerPlateSet);
    setSelectedMachinesForBuild(machine);
    const availableDatesForPickUP = machine[0].availableToPickUpDates;
    if (availableDatesForPickUP) {
      setHighlightedDatesForPickUp(availableDatesForPickUP);
    }

  }, []);

  let submitForm = "";

  const initialImoNumber = selectedMachinesForBuildProp?.imoNumber || "";
  const initialBlNumber = selectedMachinesForBuildProp?.blNumber || "";
  const initialContainerNumber = selectedMachinesForBuildProp?.containerNumber || "";
  const initialPortOfEntryId = selectedMachinesForBuildProp?.portOfEntryId || "";
  const initialPortOfExitId = selectedMachinesForBuildProp?.portOfExitId || "";
  const initialSailDate = selectedMachinesForBuildProp?.departureDateAvis || "";
  const initialEta = selectedMachinesForBuildProp?.estimatedArrivalDateAvis || "";

  const linksToUse = (transportMode === "VESSEL" || transportMode === "FERRY")
    ? selectedMachinesForBuildProp.vd_links
    : selectedMachinesForBuildProp.ta_links;

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit} className="text-md">
        <Row className="gap-6">
          <Col className="flex-1">
            {(transportMode === "VESSEL" || transportMode === "FERRY") ? (
              <VesselFormElements
                portOfExitList={locationList}
                portOfEntryList={locationList}
                vesselList={imoList}
                portError={portError}
                blNumberError={blNumberError}
                containerNumberError={containerNumberError}
                sailDateError={sailDateError}
                etaError={etaError}
                initialImoNumber={initialImoNumber}
                initialBlNumber={initialBlNumber}
                initialContainerNumber={initialContainerNumber}
                initialPortOfEntryId={initialPortOfEntryId}
                initialPortOfExitId={initialPortOfExitId}
                initialSailDate={initialSailDate}
                initialEta={initialEta}
              />
            ) : (
              <TruckFormElements
                avisDate={avisDate}
                avisDateError={avisDateError}
                avisDateErrorMessage={avisDateErrorMessage}
                estimatedArrivalDate={estimatedArrivalDate}
                estimatedArrivalDateError={estimatedArrivalDateError}
                estimatedArrivalDateErrorMessage={estimatedArrivalDateErrorMessage}
                truckPlate={truckPlate}
                truckplateError={truckplateError}
                trailorPlate={trailorPlate}
                trailorplateError={trailorplateError}
                driverName={driverName}
                driverNameError={driverNameError}
                handleTruckPlateChange={handleTruckPlateChange}
                highlightedDates={highlightedDatesForPickUp}
                transportMode={transportMode}
              />
            )}
          </Col>

          <Col className="flex-1">
            <label className="text-xs">
              Additional Information (Shipping Order)
            </label>
            <textarea
              style={{ fontSize: 12, width: "100%" }}
              className="text-xs mt-1 mb-2 p-2 w-full border-gray-500 border rounded-sm"
              placeholder="Please enter additional instuctions here.."
              name="freetext"
              rows={3}
              defaultValue={freetext}
              maxLength="400"
            ></textarea>

            <FormFileUpload onDrop={handleDrop} fileSelected={isFileSelected} />
            
            {/* Section for previously uploaded documents */}
            <div className="mt-4">
              <label className="text-xs">Uploaded Documents:</label>
              <ul className="list-disc list-inside text-xs">
                {linksToUse && linksToUse.length > 0 ? (
                  linksToUse.map((link, index) => (
                    <li key={index}>
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                      >
                        {link.fileName || "Download Document"}
                      </a>
                    </li>
                  ))
                ) : (
                  <li>No documents uploaded.</li>
                )}
              </ul>
            </div>
          </Col>
        </Row>
        <input
          className="invisible"
          ref={(input) => {
            // assigns a reference so we can trigger it later
            submitForm = input;
          }}
          type="submit"
        />
      </form>
      <FormSpinner
        startSpinner={startSpinner}
        handleCloseSpinner={handleCloseSpinner}
      />
      <br />
      <SelectedMachinesTable
        selectedMachinesForBuild={selectedMachinesForBuild}
        caller={"EditBuild"}
      />
      <br />
    </div>
  );
}
export default AvisLoadBuildForm;